import { getDate, getUnixTime } from '@einhaus/meteoric-helpers';
import type { FuturesBacktestSelection } from '@einhaus/project314-types';
export interface FuturesConfigurationDraft {
    productId: number | null;
    signalRouteId?: number | null;
    assumptionId: number | null;
    historyStart: string;
    allocation: string;
    closeBufferMinutes: string;
}
export const emptyFuturesConfiguration = (): FuturesConfigurationDraft => ({
    productId: null,
    assumptionId: null,
    historyStart: '',
    allocation: '',
    closeBufferMinutes: '1'
});

export function parseFuturesConfiguration(draft: FuturesConfigurationDraft): FuturesBacktestSelection {
    if (!draft.productId || !draft.assumptionId) throw new Error('Select a futures product and research assumption');
    if (!/^[0-9]+(?:\.[0-9]{1,2})?$/.test(draft.allocation))
        throw new Error('Enter a positive dollar allocation with at most two decimal places');
    const [whole, fraction = ''] = draft.allocation.split('.');
    const money = BigInt(whole!) * 1_000_000_000n + BigInt(fraction.padEnd(2, '0')) * 10_000_000n;
    const closeBufferSeconds = Number(draft.closeBufferMinutes) * 60;
    if (money <= 0n || !Number.isInteger(Number(draft.closeBufferMinutes)) || closeBufferSeconds < 60 || closeBufferSeconds > 86400)
        throw new Error('Allocation must be positive and the close buffer must be 1–1440 whole minutes');
    const calendarTimestamp = getUnixTime(`${draft.historyStart.replace(' ', 'T')}Z`);
    if (
        !/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:00$/.test(draft.historyStart) ||
        !Number.isFinite(calendarTimestamp) ||
        getDate({ date: calendarTimestamp, timezone: 'Etc/UTC', format: 'ymdhms' }) !== draft.historyStart
    )
        throw new Error('Enter the warmup start as YYYY-MM-DD HH:mm:00 Eastern');
    return {
        ...(draft.signalRouteId ? { signalRouteId: draft.signalRouteId } : {}),
        productId: draft.productId,
        assumptionId: draft.assumptionId,
        historyStartDateTime: draft.historyStart,
        allocationMoneyRaw: money.toString(),
        closeBufferSeconds
    };
}
